export default "__VITE_ASSET__BgwCsrln__"